<form [formGroup]="form" class="container">
  <div class="row mt-5">
    <div class="col">
      <sk-select
        formControlName="validFor"
        [items]="validityValues"
          bindLabel="name"
          bindValue="id"
        [label]="'label.dms.LinkValidity' | translate"
        data-test="file-share-link_valid-for"
      ></sk-select>
    </div>
    @if (isValidForCustom) {
      <div class="col">
        <sk-number
          formControlName="validForCustom"
          [min]="1"
          [max]="1000"
          [step]="1"
          [label]="'label.dms.CustomPeriodDays' | translate"
          data-test="file-share-link_valid-for-custom"
        ></sk-number>
      </div>
    }
    <div class="col">
      <sk-select
        formControlName="allowSingleDownloading"
        [items]="downloadValues"
        bindLabel="name"
        bindValue="id"
        [label]="'label.dms.NumberOfDownloads' | translate"
        data-test="file-share-link_allow-single-downloading"
      ></sk-select>
    </div>
  </div>

  <sk-radio-input
    formControlName="isPermanentLink"
    class="row"
    [noSubscriptBox]="true"
    [mode]="permanentLinkMode"
    [options]="permanentLinkOptions"
    [showClear]="false"
  ></sk-radio-input>

  <sk-toggle
    class="mt-2 row"
    formControlName="isSilent"
    [label]="'label.dms.IsSilent' | translate"
    data-test="file-share-link_is-silent"
  ></sk-toggle>

  @if (generatedLink()) {
    <div class="mt-2 row">
      <iris-copy-field
        [value]="generatedLink()"
        (copied)="onCopyLink()"
        data-test="file-share-link_generated-link"
      ></iris-copy-field>
    </div>
  }

  <div class="mt-3 row">
    <sk-button size="m"
               appearance="solid"
               color="primary"
               data-test="file-share-link_generate-link"
               [label]="'label.dms.FileShareGenerateLink' | translate"
               [disabled]="!isFormValid() || isLinkGenerationInProcess"
               (click)="generateLink()">
      <ng-template buttonPrefix>
        <i class="icon fas fa-fw fa-sync"></i>
      </ng-template>
    </sk-button>
  </div>
</form>

